import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import useInitApp from './App.hooks';
import NewLayout from './NewLayout/NewLayout';

export default function AppRoutes() {
  const { isLoading } = useInitApp();

  if (isLoading) {
    return <BaseLoader />;
  }

  return <NewLayout />;
}
